<div class="container modeType">
    <label>Select the mode: </label>
    <mat-radio-group id="chooseMode" [(ngModel)]="modeSelection">
        <mat-radio-button value="API">API</mat-radio-button>
        <mat-radio-button value="DataStore">DataStore</mat-radio-button>
    </mat-radio-group>
    <br>
</div>
<button mat-raised-button color="primary" id="mode_submit" (click)="onSubmit()"
    [disabled]="!modeSelection">Login</button>